export default __webpack_public_path__ + "static/media/virusunknown-250-min.70469fdd.png";